import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import CustomCard from "../../../components/common/customCard";

export default class Promotions extends Component {
  render() {
    return (
      <>
        <div className="custom-card cards-Vol px-3">
          <h5>Destinations Top</h5>

          <Row>
            <CustomCard
              IdSpe="hg-ctrl"
              size={6}
              imgPath={"/imgs/researchtypes/appartment.png"}
              linkPath={"/vols/volDetails"}
              title={"Dubai"}
              subtitle={"70000 DZD"}
            />

            <CustomCard
              IdSpe="hg-ctrl"
              size={6}
              imgPath={"/imgs/researchtypes/otdoors.png"}
              linkPath={"/"}
              title={"Turkey"}
              subtitle={"70000 DZD"}
            />
          </Row>
          <Row className="second-cards-Vol">
            <CustomCard
              IdSpe="hg-ctrl"
              size={4}
              imgPath={"/imgs/researchtypes/otdoors.png"}
              linkPath={"/"}
              title={"Maroc"}
              subtitle={"70000 DZD"}
            />{" "}
            <CustomCard
              IdSpe="hg-ctrl"
              size={4}
              imgPath={"/imgs/researchtypes/bungalo.png"}
              linkPath={"/"}
              title={"Jordan"}
              subtitle={"70000 DZD"}
            />{" "}
            <CustomCard
              IdSpe="hg-ctrl-disp"
              size={4}
              imgPath={"/imgs/researchtypes/appartment.png"}
              linkPath={"/"}
              title={"Chine"}
              subtitle={"70000 DZD"}
            />
          </Row>
        </div>

        <div
          className="d-md-none d-xl-block"
          style={{ marginTop: "40px" }}
        ></div>
        <Row>
          <Col sm="6" lg="4" className="head-promotion" id="head-promotion">
            <Col>
              <div className="after-search">
                <div className="line-after-search d-xs-block d-sm-none"></div>
                <div className="title-after-search wh-div-mr">
                  <p className="text-after-vl">
                    <img
                      src="/imgs/vols/suggestion-icons/special_offer_icn.svg"
                      className="sec-vol mr-1"
                      alt="vol"
                    />
                    Promotions
                  </p>
                </div>
              </div>
            </Col>

            <Col>
              <div id="heading1">
                <div
                  class="city"
                  data-toggle="collapse"
                  data-target="#collapse1"
                  aria-expanded="false"
                  aria-controls="collapse1"
                >
                  New York / USA
                  <img
                    src="/imgs/navebar/downArrow.svg"
                    alt="more"
                    id="arrow-parcourir-big"
                    className="arrow-right-city"
                  />
                </div>
                <div className="ft-collapse">4 Star Hotel</div>
              </div>
              <div
                id="collapse1"
                class="collapse"
                aria-labelledby="heading1"
                data-parent="#head-promotion"
              >
                <div class="card-body">
                  And lastly, the placeholder content for the third and final
                  accordion panel. This panel is hidden by default.
                </div>
              </div>
              <br />
              <hr />
            </Col>

            <Col>
              <div id="heading2">
                <div
                  class="city"
                  data-toggle="collapse"
                  data-target="#collapse2"
                  aria-expanded="false"
                  aria-controls="collapse2"
                >
                  New York / USA
                  <img
                    src="/imgs/navebar/downArrow.svg"
                    alt="more"
                    id="arrow-parcourir-big"
                    className="arrow-right-city"
                  />
                </div>
                <div className="ft-collapse">4 Star Hotel</div>
              </div>
              <div
                id="collapse2"
                class="collapse"
                aria-labelledby="heading2"
                data-parent="#head-promotion"
              >
                <div class="card-body">
                  And lastly, the placeholder content for the third and final
                  accordion panel. This panel is hidden by default.
                </div>
              </div>
              <br />
              <hr />
            </Col>

            <Col>
              <div id="heading3">
                <div
                  class="city"
                  data-toggle="collapse"
                  data-target="#collapse3"
                  aria-expanded="false"
                  aria-controls="collapse3"
                >
                  New York / USA
                  <img
                    src="/imgs/navebar/downArrow.svg"
                    alt="more"
                    id="arrow-parcourir-big"
                    className="arrow-right-city"
                  />
                </div>
                <div className="ft-collapse">4 Star Hotel</div>
              </div>
              <div
                id="collapse3"
                class="collapse"
                aria-labelledby="heading3"
                data-parent="#head-promotion"
              >
                <div class="card-body">
                  And lastly, the placeholder content for the third and final
                  accordion panel. This panel is hidden by default.
                </div>
              </div>
              <br />
              <hr />
            </Col>

            <Col>
              <div id="heading4">
                <div
                  class="city"
                  data-toggle="collapse"
                  data-target="#collapse4"
                  aria-expanded="false"
                  aria-controls="collapse4"
                >
                  New York / USA
                  <img
                    src="/imgs/navebar/downArrow.svg"
                    alt="more"
                    id="arrow-parcourir-big"
                    className="arrow-right-city"
                  />
                </div>
                <div className="ft-collapse">4 Star Hotel</div>
              </div>
              <div
                id="collapse4"
                class="collapse"
                aria-labelledby="heading4"
                data-parent="#head-promotion"
              >
                <div class="card-body">
                  And lastly, the placeholder content for the third and final
                  accordion panel. This panel is hidden by default.
                </div>
              </div>
              <br />
              <hr />
            </Col>
          </Col>

          <Col sm="6" lg="4" className="head-promotion">
            <div className="after-search">
              <div className="line-after-search d-xs-block d-sm-none"></div>
              <div className="title-after-search wh-div-lg">
                <p className="text-after-vl">
                  <img
                    src="/imgs/vols/suggestion-icons/first_minute_icn.svg"
                    className="sec-vol  mr-1"
                    alt="vol"
                  />
                  Offres premiére minute
                </p>
              </div>
            </div>

            <Col>
              <div className="city">
                New York / USA
                <img
                  src="/imgs/navebar/downArrow.svg"
                  alt="more"
                  id="arrow-parcourir-big"
                  className="arrow-right-city"
                />
              </div>
              <div className="ft-collapse">4 Star Hotel</div>
              <br />

              <hr />
            </Col>
            <Col>
              <div className="city">
                New York / USA
                <img
                  src="/imgs/navebar/downArrow.svg"
                  alt="more"
                  id="arrow-parcourir-big"
                  className="arrow-right-city"
                />
              </div>
              <div className="ft-collapse">4 Star Hotel</div>
              <br />

              <hr />
            </Col>
            <Col>
              <div className="city">
                New York / USA
                <img
                  src="/imgs/navebar/downArrow.svg"
                  alt="more"
                  id="arrow-parcourir-big"
                  className="arrow-right-city"
                />
              </div>
              <div className="ft-collapse">4 Star Hotel</div>
              <br />
              <hr />
            </Col>
          </Col>
          <Col sm="6" lg="4" className="head-promotion">
            <div className="after-search">
              <div className="line-after-search d-xs-block d-sm-none"></div>
              <div className="title-after-search wh-div-lg">
                <p className="text-after-vl">
                  <img
                    src="/imgs/vols/suggestion-icons/clock_icn.svg"
                    className="sec-vol  mr-1"
                    alt="vol"
                  />
                  Offres derniére min
                </p>
              </div>
            </div>
            <Col>
              <div className="city">
                New York / USA
                <img
                  src="/imgs/navebar/downArrow.svg"
                  alt="more"
                  id="arrow-parcourir-big"
                  className="arrow-right-city"
                />
              </div>
              <div className="ft-collapse">4 Star Hotel</div>
              <br />

              <hr />
            </Col>
            <Col>
              <div className="city">
                New York / USA
                <img
                  src="/imgs/navebar/downArrow.svg"
                  alt="more"
                  id="arrow-parcourir-big"
                  className="arrow-right-city"
                />
              </div>
              <div className="ft-collapse">4 Star Hotel</div>
              <br />

              <hr />
            </Col>
            <Col>
              <div className="city">
                New York / USA
                <img
                  src="/imgs/navebar/downArrow.svg"
                  alt="more"
                  id="arrow-parcourir-big"
                  className="arrow-right-city"
                />
              </div>
              <div className="ft-collapse">4 Star Hotel</div>
              <br />

              <hr />
            </Col>
          </Col>
        </Row>
      </>
    );
  }
}